/**
 * CRA(webpack ProvidePlugin) 가 주입하던 Node 전역 `Buffer` 를 Vite 에서도 제공한다.
 * 소스의 base64 인코딩·디코딩(JWT 페이로드 등 17곳)과 일부 의존성이 전역 Buffer 를 쓴다.
 * 다른 모듈보다 먼저 평가되도록 src/index.js 의 첫 import 로 둔다.
 */
import { Buffer } from "buffer";

if (!globalThis.Buffer) globalThis.Buffer = Buffer;
